module.exports = __webpack_public_path__ + "assets/img/btn-view-mecha-info-41537bcb.png";